module.exports = __webpack_public_path__ + "5d8e9988248147c38ca268a3571000b7.fbx";